import { render, staticRenderFns } from "./updateOrCreateQuestion.vue?vue&type=template&id=4d25c54b"
import script from "./updateOrCreateQuestion.vue?vue&type=script&lang=js"
export * from "./updateOrCreateQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports